import React, { createContext, useEffect, useState } from "react";
import PlantillaScreen from "../../helpers/PlantillaScreen";
import { LoaderScreen } from "../../components/LoaderScreen";
import request from "../../../Helpers/API";
import Swal from "sweetalert2";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import EditNoteIcon from "@mui/icons-material/EditNote";
import JoinFullIcon from "@mui/icons-material/JoinFull";
import { TextField } from "@mui/material";
import { useHistory } from "react-router-dom";
import SearchIcon from '@mui/icons-material/Search';
import VisibilityIcon from '@mui/icons-material/Visibility';
import CallIcon from '@mui/icons-material/Call';

export const ContextConvenio = createContext();
export const ConvenioPagoMain = () => {
  const history = useHistory();
  const [selected, setSelected] = useState([]);
  const [predictivo, setPredictivo] = useState("");
  const [clientes, setClientes] = useState([]);
  const [arrayClientes, setArrayClientes] = useState([]);
  const [loader, setLoader] = useState({
    mostrar: false,
    alerta: false,
    error: false,
    mensaje: "",
  });

  useEffect(() => {
    setLoader({ ...loader, mostrar: true });
    request
      .get(`ConvenioClientesVencidos/ClientesVencidos`)
      .then((result) => {
        setClientes(result);
        setArrayClientes(result);
        setLoader({ ...loader, mostrar: false });
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire("CONVENIO DE PAGO", JSON.stringify(error), "error");
      });
  }, []);

  useEffect(() => {
    const result = arrayClientes.filter((item) =>
      item.razonsocial.toUpperCase().includes(predictivo.toUpperCase())
    );
    setSelected([]);
    setClientes(result);
  }, [predictivo]);

  const onCheck = (target, registro) => {
    const idcliente = target.value;
    const checked = target.checked;
    var options = selected.filter((item) => item.idcliente !== idcliente);
    if (checked === true) {
      if (
        registro === "HD" &&
        selected.filter((item) => item.registro === "HD").length > 0
      ) {
        target.checked = false;
      } else {
        options = [...options, { idcliente, registro }];
      }
    }
    setSelected(options);
  };
  const onRegistrar = (idcliente, razonsocial) => {
    history.push("/Creditoycobranza/CombinarClientes", {
      idcliente,
      razonsocial,
    });
  };
  const onConvenio = (idcliente, razonsocial) => {
    history.push("/Creditoycobranza/ListadoConvenios", {
      idcliente,
      razonsocial,
    });
  };
  const onDatosContacto = (idcliente, razonsocial) => {
    history.push("/Creditoycobranza/DatosContacto", {
      idcliente,
      razonsocial,
    });
  };
  const onCombinar = () => {
    if (selected.length > 1)
      history.push("/Creditoycobranza/CombinarClientes", {
        selected,
      });
  };
  const capitalizeWords = (text) => {
    return text
      .toLowerCase()
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  };

  return (
    <PlantillaScreen
      titulo={"SELECCIONAR CLIENTE"}
      className={"convenio-pago-main-screen"}
      className_main={1}
    >
      <LoaderScreen loader={loader} />
      <div className="convenio-clientes-vencidos">
        <div className="convenio-clientes-vencidos-header">
          <div className="convenio-clientes-vencidos-header-control">
            <TextField
              color="success"
              fullWidth
              size="small"
              value={predictivo}
              onChange={({ target }) => setPredictivo(target.value)}
              placeholder="Buscar Clientes..."
            />
          </div>
          {/* {selected.length > 0 && (
            <div
              className="convenio-clientes-vencidos-header-button"
              onClick={() => onCombinar()}
            >
              <JoinFullIcon />
              COMBINAR
            </div>
          )} */}
        </div>
        <div className="convenio-clientes-vencidos-container scroll-4">
          {clientes !== undefined &&
            clientes !== null &&
            clientes.length > 0 ? (
            <table cellSpacing={0} cellPadding={0}>
              <thead>
                <tr>
                  <th colSpan={4}>Clientes</th>
                </tr>
              </thead>
              <tbody>
                {clientes.map((ctl) => (
                  <tr>
                    <td className="id-cliente-celda">
                      {/* <input
                        type="checkbox"
                        value={ctl.idcliente}
                        onChange={({ target }) => onCheck(target, ctl.registro)}
                      /> */}
                      {ctl.idcliente}
                    </td>
                    <td className="razon-social-celda">{capitalizeWords(ctl.razonsocial)}</td>
                    <td className="datos-contacto-celda">
                      <div className="clientes-datos-contacto-button">
                        <div className="datos-contacto" onClick={() => onDatosContacto(ctl.idcliente, ctl.razonsocial)}>
                          <CallIcon /> Datos de Contacto
                        </div>
                      </div>
                    </td>
                    <td className="convenio-clientes-vencidos-celda">
                      {" "}
                      {selected.length === 0 && (
                        <div className="convenio-clientes-vencidos-button">
                          {ctl.registro === "HD" ? (
                            <div
                              className="convenio"
                              onClick={() =>
                                onConvenio(ctl.idcliente, ctl.razonsocial)
                              }
                            >
                              <VisibilityIcon /> Ver informacion
                            </div>
                          ) : (
                            <div
                              className="registro"
                              onClick={() =>
                                onRegistrar(ctl.idcliente, ctl.razonsocial)
                              }
                            >
                              <EditNoteIcon />
                              Registrar
                            </div>
                          )}
                        </div>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <div>Sin Datos</div>
          )}
          <div>
            <table></table>
          </div>
        </div>
        <div className="convenio-clientes-vencidos-footer">
          Total de Clientes Vencidos: {clientes.length}
        </div>
      </div>
    </PlantillaScreen>
  );
};
